// @ts-expect-error The generated inline sprite module has no TypeScript declaration.
import svgSprite from "../../../public/assets/icons/icons.sprite.inline.ecco";

export const SvgSprite = () => {
    return (
        <div
            style={{ display: "none", visibility: "hidden" }}
            aria-hidden="true"
            // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml -- The generated inline SVG sprite is a trusted build artifact.
            dangerouslySetInnerHTML={{ __html: svgSprite }}
        />
    );
};
